import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Dropbox = (props: TIconProps): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="hsl(from hsl(217 100% 50%) h s 50%)"
    {...props}
  >
    <path d="M6 2L0 5.75 6 9.5l6-3.75L6 2zM18 2l-6 3.75 6 3.75 6-3.75L18 2zM0 13.25L6 17l6-3.75-6-3.75L0 13.25zM18 9.5l-6 3.75 6 3.75 6-3.75L18 9.5zM6 18.25L12 22l6-3.75-6-3.75-6 3.75z" />
  </svg>
);
